import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { mediaHelper } from '@property.com.au/ui-kit';
import { ShowcaseItem } from '../ShowcaseItem/ShowcaseItem';
import {
  MediaShowcaseV2AerialItem,
  MediaShowcaseV2ListingItem,
} from '../../../../../app-kit/components/Image/types';
import {
  MEDIA_SHOWCASE_BRICK_HEIGHT,
  MEDIA_SHOWCASE_BRICK_HEIGHT_MOBILE,
} from '../../MediaShowcaseBrick.styled';

const gap = '4px';

const SplitItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${gap};
  height: 100%;
  width: 100%;

  ${mediaHelper('tabletMin')} {
    flex-direction: row;
  }
`;

const FeatureItemContainer = styled.div`
  width: 100%;
  height: 60%;
  ${mediaHelper('tabletMin')} {
    width: 70%;
    height: 100%;
  }
`;

const SupportingItemsContainer = styled.div`
  display: flex;
  width: 100%;
  height: 40%;
  gap: ${gap};
  max-height: ${MEDIA_SHOWCASE_BRICK_HEIGHT_MOBILE}px;

  > * {
    width: calc(50% - ${gap} / 2);
    height: 100%;
  }

  ${mediaHelper('tabletMin')} {
    width: 30%;
    height: 100%;
    flex-direction: column;
    max-height: ${MEDIA_SHOWCASE_BRICK_HEIGHT}px;

    > * {
      height: calc(50% - ${gap} / 2);
      width: 100%;
    }
  }
`;

interface MediaShowcaseSplitProps {
  items: {
    main: MediaShowcaseV2ListingItem;
    secondary: MediaShowcaseV2ListingItem | MediaShowcaseV2AerialItem;
    tertiary: MediaShowcaseV2ListingItem;
  };
  showSearchByImage?: boolean;
}

export const MediaShowcaseSplit: FunctionComponent<MediaShowcaseSplitProps> = ({
  items: { main, secondary, tertiary },
}) => {
  return (
    <SplitItemsContainer>
      <FeatureItemContainer>
        <ShowcaseItem item={main} />
      </FeatureItemContainer>
      <SupportingItemsContainer>
        <ShowcaseItem item={secondary} />
        <ShowcaseItem item={tertiary} />
      </SupportingItemsContainer>
    </SplitItemsContainer>
  );
};
